import { SubmitHandler } from 'react-hook-form';
import { StyleSheet, View } from 'react-native';
import Animated, { useAnimatedRef } from 'react-native-reanimated';

import { Chat, ChatRoom, NewMessageData } from '@/api/models/chatRoomModels';
import { ChatActions } from '@/constants/enums/ChatActions';
import { firebaseImage, safeJsonParseArray } from '@/utils/firebaseImage';

import ChatMessage from './ChatMessage.web';

interface ChatListWithoutInputProps {
  chatRoom: ChatRoom;
  chats: Chat[];
  inverted?: boolean;
  msgResponded?: (data: NewMessageData) => void;
}

const ChatListWithoutInput = ({ chatRoom, chats, inverted = true, msgResponded }: ChatListWithoutInputProps) => {
  const flatListRef = useAnimatedRef<Animated.FlatList<string>>();

  const onMsgResponded: SubmitHandler<NewMessageData> = async (data) => {
    if (msgResponded) msgResponded(data);
  };

  const thumbnail = safeJsonParseArray(chatRoom.thumbnail ?? '[]');

  const actions = msgResponded ? [{ title: ChatActions.RESPOND }] : [];

  return (
    <View style={styles.container}>
      <Animated.FlatList
        ref={flatListRef}
        inverted={inverted}
        data={chats}
        keyExtractor={(item: Chat) => item.id}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={styles.flatListContainer}
        renderItem={(chat: { item: Chat; index: number }) => (
          <ChatMessage
            roomId={chatRoom.id ?? ''}
            chat={chat.item}
            thumbnail={thumbnail && thumbnail.length > 0 ? firebaseImage(thumbnail[0]) : undefined}
            sender={chatRoom.title ?? '-'}
            roomSubtitle={chatRoom.subtitle}
            actions={actions}
            onRespond={(data) => {
              flatListRef.current?.scrollToIndex({ index: chat.index, animated: true });
              onMsgResponded(data);
            }}
          />
        )}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  flexOne: {
    flex: 1
  },

  container: {
    flexDirection: 'column',
    height: '100%'
  },

  list: {
    height: '100%'
  },

  flatListContainer: {
    paddingVertical: 20,
    paddingHorizontal: 18
  },

  separator: {
    marginBottom: 20
  }
});

export default ChatListWithoutInput;
